var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 16.6667L2.08398 17.9167M16.6673 3.33333L17.9173 2.08333M12.9173 7.08333L7.08398 12.9167",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 3.33333L13.0891 3.08926C12.7637 2.76382 12.236 2.76382 11.9106 3.08926L11.0058 3.99408C10.6804 4.31952 10.6804 4.84715 11.0058 5.17259L14.8273 8.99408C15.1527 9.3195 15.6804 9.3195 16.0058 8.99408L16.9106 8.08926C17.236 7.76382 17.236 7.23618 16.9106 6.91074L16.6665 6.66667M13.3332 3.33333L14.4106 2.25593C14.736 1.93048 15.2637 1.93048 15.5891 2.25593L17.7439 4.41074C18.0694 4.73618 18.0694 5.26382 17.7439 5.58926L16.6665 6.66667M13.3332 3.33333L16.6665 6.66667",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66654 16.6667L6.91062 16.9108C7.23606 17.2362 7.76369 17.2362 8.08913 16.9108L8.99396 16.0059C9.31938 15.6805 9.31938 15.1528 8.99396 14.8274L5.17247 11.0059C4.84703 10.6805 4.31939 10.6805 3.99395 11.0059L3.08913 11.9108C2.76369 12.2362 2.76369 12.7638 3.08913 13.0893L3.33321 13.3333M6.66654 16.6667L5.58913 17.7441C5.26369 18.0695 4.73606 18.0695 4.41062 17.7441L2.2558 15.5893C1.93036 15.2638 1.93036 14.7362 2.2558 14.4108L3.33321 13.3333M6.66654 16.6667L3.33321 13.3333",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutIcon);
export default __webpack_public_path__ + "static/media/workout-icon.ff27092d79731f6140cc766644cb13b0.svg";
export { ForwardRef as ReactComponent };